import type { Theme } from '@mui/material';

export const styles = {
  headerContainer: {
    height: '100%',
    justifyContent: 'flex-end',
    maxWidth: '1024px',
    width: '100%',
    margin: '0 auto',
  },

  headerLogo: (theme: Theme) => ({
    fill: theme.colors.primary[600],
    height: '100%',
    width: 'auto',
  }),

  surveyLogo: (theme: Theme) => ({
    height: '100%',
    maxHeight: '4.5rem',
    marginBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
  }),

  brandLogoWrapper: {
    overflow: 'hidden',
    pt: 3.75,
    height: '100%',
    flexGrow: 1,

    '> img': {
      objectFit: 'contain',
    },
  },

  headerBanner: (theme: Theme) => ({
    height: '50%',
    color: theme.colors.black,

    '> *': {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    },
  }),

  followUpIconWrapper: (theme: Theme) => ({
    ml: 'auto',
    height: '100%',
    svg: {
      marginBottom: 1,
      height: '100%',
      width: 'auto',
      fill: theme.colors.black,
    },
  }),
  langSwitcher: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginY: '0.5rem',
  },
};
